export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20community%20gathering%20concept%20illustration%2C%20warm%20coral%20and%20amber%20tones%2C%20abstract%20figures%20connected%20in%20social%20network%20pattern%2C%20editorial%20Chinese%20digital%20media%20aesthetic%2C%20soft%20atmospheric%20lighting%2C%20clean%20minimal%20composition%2C%20harmonious%20warm%20color%20palette&width=700&height=525&seq=about-section-visual&orientation=landscape"
                alt="51吃瓜每日大赛 - 全网最活跃的吃瓜社区平台介绍"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              关于51吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              51吃瓜每日大赛成立于2023年，是国内领先的泛娱乐资讯聚合平台。我们致力于为吃瓜群众打造一个信息全面、更新及时、内容真实的吃瓜社区。平台每日聚合来自娱乐圈、网红圈、商业圈等多个领域的最新爆料与深度解读，累计服务超过280万活跃用户。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们坚持"快、准、全"的内容理念——快在第一时间推送热点，准在多方核实确保信息真实，全在覆盖范围广泛不留死角。无论是顶流明星的塌房大瓜，还是网红圈的互撕内幕，亦或是商业大佬的秘闻轶事，这里都是你吃瓜的第一站。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              目前平台日均更新爆料内容超过百条，拥有超过50万的累计爆料数据库。欢迎每一位吃瓜群众加入我们，一起分享、讨论、见证每一个值得关注的大瓜。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}